import React from 'react';

//styles
import styles from './DynamicTabSystem.module.scss';
import { useTranslation } from 'react-i18next';

export default function DynamicPanel(props: {
  title: string;
  isActive: boolean;
  goodComponent: JSX.Element | null;
}) {
  const { t } = useTranslation();
  return (
    <div
      hidden={props.isActive}
      className={
        styles[`${props.title === t('Dashboard') ? 'dynamic-panel-dark' : 'dynamic-panel-light'}`]
      }
    >
      {props.goodComponent}
    </div>
  );
}
